import {Component, Input, OnInit} from '@angular/core';
import {Parametrage} from '../../parametrage/parametrage.model';
import {CALENDAR_FR} from '../../../shared/calendar/calendar.constants';

@Component({
    selector: 'jhi-parametre-component',
    templateUrl: 'parametre.component.html'
})

export class ParametreComponent {

    @Input() parametrages: Parametrage[];
    @Input() currentLang: string;


    fr: any;

    constructor() {
    }

    ngOnInit() {
        this.fr = CALENDAR_FR;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/blocks/parametre/parametre.component.ts